import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

const googleClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

const root = ReactDOM.createRoot(document.getElementById("root"));
const app = <App />;
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {googleClientId ? (
        <GoogleOAuthProvider clientId={googleClientId}>
          {app}
        </GoogleOAuthProvider>
      ) : (
        app
      )}
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA functionality (mobile only)
if ('serviceWorker' in navigator) {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (isMobile) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
        .then((registration) => {
          console.log('SW registered: ', registration);
          registration.update();
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  window.location.reload();
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
      // No reload on controllerchange: we already reload once when the new worker is installed
    });
  }
}
